import React from "react";
import { PaperProps } from "@mui/material";

import { Container } from "./PageCard.styled";

interface IPageCardPrps extends PaperProps {
  minHeight?: string;
}

const PageCard: React.FC<IPageCardPrps> = ({ children, ...rest }) => {
  return (
    <Container elevation={6} {...rest} sx={{ minHeight: rest.minHeight }}>
      {children}
    </Container>
  );
};

export { PageCard };
